import { Link, useLocation } from 'react-router-dom'
import { HELP_SECTIONS } from '@/lib/helpPortal'

/**
 * Help portal sidebar navigation. Uses aria-current="page" for current route; keyboard-accessible.
 */
export default function HelpNav() {
  const location = useLocation()

  return (
    <nav aria-label="Help sections" className="flex flex-col gap-1">
      <ul className="list-none p-0 m-0 flex flex-col gap-1">
        {HELP_SECTIONS.map((section) => {
          const isCurrent = location.pathname === section.path
          return (
            <li key={section.id}>
              <Link
                to={section.path}
                className="block px-4 py-2 rounded min-h-[44px] flex items-center"
                style={{
                  color: 'var(--text-primary)',
                  backgroundColor: isCurrent ? 'var(--bg-secondary)' : 'transparent',
                  borderLeft: isCurrent ? '3px solid var(--color-focus)' : '3px solid transparent',
                  textDecoration: 'none',
                }}
                aria-current={isCurrent ? 'page' : undefined}
              >
                {section.label}
              </Link>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
